import {
  LOGIN_DELIVERY_USER,
  LOGOUT_DELIVERY_USER,
  UPDATE_DELIVERY_USER_INFO,
  UPDATE_DELIVERY_ORDER_HISTORY,
  LEADER_BOARD,
  REQUEST_PAYOUT,
  VIEW_PAYOUT,
  REGISTER_DELIVERY_USER,
  REGISTER_UPDATE_USER,

} from "./actionTypes";
import {
  LOGIN_DELIVERY_USER_URL,
  UPDATE_DELIVERY_USER_INFO_URL,
  LEADER_BOARD_URL,
  REQUEST_DELIVERY_GUY_PAYOUT,
  GET_DELIVERY_GUY_PAYOUT,
  REGISTER_DELIVERY_USER_URL,

  REGISTER_UPDATE_DATA_URL,
} from "../../../configs";

import Axios from "axios";

export const loginDeliveryUser = (email, password) => (dispatch) => {
  Axios.post(LOGIN_DELIVERY_USER_URL, {
    email: email,
    password: password,
  })
    .then((response) => {
      const delivery_user = response.data;
      return dispatch({ type: LOGIN_DELIVERY_USER, payload: delivery_user });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const registerDeliveryUser = (formData) => (dispatch) => {
  return Axios.post(REGISTER_DELIVERY_USER_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      const delivery_user = response.data;
      dispatch({ type: REGISTER_DELIVERY_USER, payload: delivery_user });

      if (delivery_user.data?.auth_token) {
        localStorage.setItem("auth_token", delivery_user.data.auth_token);
      }

      return { success: true, token: delivery_user.data?.auth_token || null }; // Return token
    })
    .catch((error) => {
      console.error(
        "Error registering delivery user:",
        error.response?.data || error.message
      );
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during registration.";
      return { success: false, message: errorMessage };
    });
};

export const registerUpdateData = (token, formData) => (dispatch) => {
  return Axios.post(REGISTER_UPDATE_DATA_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      const update_user = response.data;
      dispatch({ type: REGISTER_UPDATE_USER, payload: update_user });
      return { success: true };
    })
    .catch((error) => {
      console.error(
        "Error updating user:",
        error.response?.data || error.message
      );
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during update registration.";
      return { success: false, message: errorMessage };
    });
};

export const logoutDeliveryUser = (delivery_user) => (dispatch) => {
  delivery_user = [];
  dispatch({
    type: LOGOUT_DELIVERY_USER,
    payload: delivery_user,
  });
  window.location.href = "/login";
};

export const updateDeliveryUserInfo = (user_id, token) => (dispatch) => {
  Axios.post(UPDATE_DELIVERY_USER_INFO_URL, {
    token: token,
    user_id: user_id,
  })
    .then((response) => {
      const data = {
        delivery_user: response.data,
        order_history: response.data.data.orders,
      };
      return dispatch({ type: UPDATE_DELIVERY_USER_INFO, payload: data });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateDeliveryOrderHistory = (order_history) => (dispatch) => {
  dispatch({
    type: UPDATE_DELIVERY_ORDER_HISTORY,
    payload: order_history,
  });
};

export const getTopAgents = (token) => (dispatch) => {
  Axios.post(LEADER_BOARD_URL, {
    token,
  })
    .then((response) => {
      // console.log(response);

      const leader_board = response.data;
      return dispatch({
        type: LEADER_BOARD,
        payload: {
          global_points: response.data.global_points,
          team_ranked_agents: response.data.team_ranked_agents,
          user_ranks: response.data.user_ranks,
          agent_team: response.data.agent_team,
        },
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const agentRequestPayout = (token) => (dispatch) => {
  console.log(token);
  Axios.post(REQUEST_DELIVERY_GUY_PAYOUT, {
    token,
  })
    .then((response) => {
      // console.log(response);
      const data = response.data;
      return dispatch({
        type: REQUEST_PAYOUT,
        payload: { success: response.data.success, data: response.data.data },
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getAgentPayouts = (token) => (dispatch) => {
  // console.log(token);
  Axios.post(GET_DELIVERY_GUY_PAYOUT, {
    token,
  })
    .then((response) => {
      return dispatch({
        type: VIEW_PAYOUT,
        payload: {
          success: response.data.success,
          payouts: response.data.payouts,
          amount: response.data.amount,
        },
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
